import React from "react";
import { Plus } from "lucide-react";

const DirectorDashboardHeader = ({ navigate }) => {
  return (
    <div className="dd-header">
      <div>
        <h1 className="dd-title">Director Dashboard</h1>
        <p className="dd-subtitle">Manage your vision. Review applicants and active roles seamlessly.</p>
      </div>
      <button className="dd-btn-primary" onClick={() => navigate('/dashboard/post-roles')}>
        <Plus size={18} /> Post New Role
      </button>
    </div>
  );
};

export default DirectorDashboardHeader;
